// Background video: keep the responsive poster until playback actually starts.
class LKVisibleVideo extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.video = this.querySelector('video');
    if (!this.video) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.video.muted = true;
    this.video.addEventListener('playing', () => {
      this.setAttribute('data-ready', '');
      if (!this.shouldPlay()) this.video.pause();
    }, { signal });
    const update = () => this.update();
    this.motion.addEventListener('change', update, { signal });
    document.addEventListener('visibilitychange', update, { signal });
    this.observer = new IntersectionObserver(([entry]) => {
      this.inView = entry.isIntersecting;
      this.update();
    }, { threshold: 0.05 });
    this.observer.observe(this.video);
  }

  shouldPlay() {
    return this.isConnected && this.inView && !document.hidden && !this.motion.matches;
  }

  update() {
    if (!this.shouldPlay()) {
      this.video.pause();
      return;
    }
    const sources = this.video.querySelectorAll('source[data-src]');
    for (const source of sources) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    }
    if (sources.length) this.video.load();
    this.video.play()?.catch(() => {});
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    this.observer?.disconnect();
    this.inView = false;
    this.video?.pause();
  }
}

if (!customElements.get('lk-visible-video')) customElements.define('lk-visible-video', LKVisibleVideo);
